import script from "./BanksSect.vue?vue&type=script&lang=ts&setup=true"
export * from "./BanksSect.vue?vue&type=script&lang=ts&setup=true"

import "./BanksSect.vue?vue&type=style&index=0&id=97267a96&lang=scss"

const __exports__ = script;

export default __exports__